import { render, staticRenderFns } from "./ButtonPill.vue?vue&type=template&id=6cf49df1&scoped=true&"
import script from "./ButtonPill.vue?vue&type=script&lang=ts&"
export * from "./ButtonPill.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPill.vue?vue&type=style&index=0&id=6cf49df1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf49df1",
  null
  
)

export default component.exports